import { showAttendeeDetails } from "./show_attendee_details";
import { toggleAttendeeDetails } from "../events/programs";
export let programs = [];
export const showAdminPrograms = (program) => {
  programs = program;
  // create elements
  let row = "";

  if (programs.webconference.length == 0) {
    row = show_no_program();
  } else {
    row = program_info(programs);
  }
};

const show_no_program = () => {
  return `<tr><td colspan="4">
    <div class="col-12 text-center">
        No Program added at this time.
    </div> 
  </td></tr>`;
};

const program_info = (program) => {
  console.log(program);
  let attendees = program.attendees;
  let liveAttendance = attendees.filter((live) => live.attending_status == 1);
  let virtualAttendance = attendees.filter(
    (virtual) => virtual.attending_status == 2
  );

  let live_attendance = document.getElementById("live_attendance");
  let virtual_attendance = document.getElementById("virtual_attendance");
  live_attendance.innerHTML = "";
  virtual_attendance.innerHTML = "";
  live_attendance.innerHTML = liveAttendance.length;
  virtual_attendance.innerHTML = virtualAttendance.length;
};

export const handleAttendeeDetails = (e) => {
  e.preventDefault();
  toggleAttendeeDetails(e);
  console.log(programs);
  showAttendeeDetails(programs);
};
